import { WEBSITE_GA_TRACKING_ID } from 'config';

// Google tag cookie formats are undocumented. These match the values the
// website's Google tag writes on .headliner.app.
export const GOOGLE_CLIENT_ID_COOKIE = '_ga';
export const GOOGLE_SESSION_COOKIE =
  WEBSITE_GA_TRACKING_ID && `_ga_${WEBSITE_GA_TRACKING_ID.replace(/^G-/, '')}`;
export const GOOGLE_GCLID_COOKIE = '_gcl_aw';
export const GOOGLE_WBRAID_COOKIE = '_gcl_gb';
export const GOOGLE_GBRAID_COOKIE = '_gcl_ag';

// GA1.<n>.<random>.<first visit timestamp>, where the client id is the last two fields
export const GOOGLE_CLIENT_ID_COOKIE_PATTERN = /^GA\d+\.\d+\.(\d+\.\d+)$/;
// GS2.<n>.s<session id>$o<session count>$…, with "$"-separated fields in no guaranteed order
export const GOOGLE_SESSION_COOKIE_PATTERN =
  /^GS2\.\d+\.(?:[^$]*\$)*s(\d+)(?:\$|$)/;
// GCL.<stored at>.<click id>[.<conversion label>…]
export const GOOGLE_CLICK_ID_COOKIE_PATTERN = /^GCL\.\d+\.([\w-]+)(?:\.|$)/;
// <n>.<n>.k<gbraid>$i<stored at>[$b<conversion label>], with "$"-separated fields in no guaranteed order
export const GOOGLE_GBRAID_COOKIE_PATTERN = /^\d+\.\d+\.(?:[^$]*\$)*k([^$]+)/;
